import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Moment from 'moment';

import FirebaseService from '../../../services/firebase';
import playImg from '../../../assets/play.png';

const UserDetail = (props) => {
    const [contact, setContact] = useState(null);
    const [contactAccount, setContactAccount] = useState(null);
    const [accountConfig, setAccountConfig] = useState(null);
    const [stageOpen, setStageOpen] = useState(false);
    const [stepOpen, setStepOpen] = useState(false);

    const getContactData = async (id) => {
        let contactData = await FirebaseService.getUserData(id);
        console.log(contactData.data())
        setContact(contactData?.data());
        getContactAccountData(contactData.get('accountId'))
    }


    const getContactAccountData = async (id) => {
        let accountData = null;
        if (id) {
            accountData = (await FirebaseService.getAccount(id)).data();
        }
        setContactAccount(accountData);
    }

    const updateAccount = (data) => {
        if (contactAccount) {
            FirebaseService.updateContactAccountData(contactAccount.accountId, data)
            setContactAccount({...contactAccount, ...data})
        }
    }

    const getAccountConfig = async () => {
        const config = await FirebaseService.getConfig('accounts');
        console.log('CONFIG', config);
        setAccountConfig(config.data())
    }

    const openForm = (field) => {
        switch (field) {
            case 'stage': return setStageOpen(!stageOpen);
            case 'step': return setStepOpen(!stepOpen);
        }
    }


    useEffect(() => {
        setContact(null);
        setContactAccount(null);
        setStageOpen(false)
        setStepOpen(false)

        if (props.contactId) getContactData(props.contactId)
        if (!accountConfig) getAccountConfig()
    }, [props]);

    return (
        <div className="user-info-component">
            {contact && <Form>
                <p><b>Nome:</b> {contact.name}</p>
                <p><b>Email:</b> {contact.email}</p>
                <p><b>Status:</b> {contact.status}</p>

                <p><b>Categoria:</b> {contact.addict?.addictionId}</p>
                <p><b>Data Inicial:</b> {Moment(contact.addict?.endDate?.toDate()).format('ll')}</p>
                <p><b>Membro desde:</b> {Moment(contact.createdAt?.toDate()).format('ll')}</p>

                <p className="click" onClick={() => openForm('step')}>
                    <img className={"menu-icon " + (stepOpen ? 'open' : '')} src={playImg}/>
                    <b>Degraus:</b> {contact.steps ? null : 'sem degraus'}
                </p>
                <div className={"degraus " + (stepOpen ? 'open' : '')}>
                    {contact.steps ? Object.keys(contact.steps)?.map(key1 => {
                        return (
                            <div className="step">
                                <p className="step1"><b>{key1}:</b></p>
                                {Object.keys(contact.steps[key1]).map(key2 => {
                                    return <p className="step2"><b>{key2}:</b> {contact.steps[key1][key2] ? 'true' : 'false'}</p>
                                })}
                            </div>
                        )
                    }) : null}
                </div>

                <p className="click" onClick={() => openForm('stage')}>
                    <img className={"menu-icon " + (stageOpen ? 'open' : '')} src={playImg}/>
                    <b>Depoimentos:</b> {contact.stages ? null : 'sem depoimentos'}
                </p>
                <div className={"stages " + (stageOpen ? 'open' : '')}>
                    {contact.stages ? Object.keys(contact.stages).map(key1 => {
                        return <p className="stage"><b>{key1}:</b> {contact.stages[key1]}</p>
                    }) : null}
                </div>


                <p><b>Audios:</b> {contact.audioInteractions}</p>
                <p><b>Leituras:</b> {contact.infoInteractions}</p>
                <p><b>Reuniões:</b> {contact.meetingsConfirmations}</p>
                <p><b>Plano:</b> {contactAccount?.planId}</p>
                <p><b>Vencimento:</b> {Moment(contactAccount?.payment?.endDate?.toDate()).format('ll')}</p>
                <p><b>Status Plano:</b> {contactAccount?.payment?.status}</p>

                <Form.Group controlId="godfather">
                    <Form.Label>Padrinho</Form.Label>
                    <Form.Control as="select" custom
                        value={contactAccount?.godfather}
                        onChange={event => updateAccount({ godfather: event.target.value })}>
                        <option value="">Selecione um Padrinho</option>
                        {accountConfig?.godfatherList?.map(user => {
                            return <option value={user.id}>{user.name}</option>
                        })}
                    </Form.Control>
                </Form.Group>


                <Form.Group controlId="psychiatrist">
                    <Form.Label>Psiquiatra</Form.Label>
                    <Form.Control as="select" custom
                        value={contactAccount?.psychiatrist}
                        onChange={event => updateAccount({ psychiatrist: event.target.value })}>
                        <option value="">Selecione um Psiquiatra</option>
                        {accountConfig?.psychiatristList?.map(user => {
                            return <option value={user.id}>{user.name}</option>
                        })}
                    </Form.Control>
                </Form.Group>


                <Form.Group controlId="therapist">
                    <Form.Label>Terapeuta</Form.Label>
                    <Form.Control as="select" custom
                        value={contactAccount?.therapist}
                        onChange={event => updateAccount({ therapist: event.target.value })}>
                        <option value="">Selecione um Terapeuta</option>
                        {accountConfig?.therapistList?.map(user => {
                            return <option value={user.id}>{user.name}</option>
                        })}
                    </Form.Control>
                </Form.Group>
            </Form>}
        </div>
    );
}

export default UserDetail;